module.exports = "/images/vendor/flag-icon-css/flags/1x1/bs.svg?6fe877e157af3feb09878e657d8ad1f7";